export default {
  header: "About",
  view: "about"
};
